{
  "MACROS": {
    "HEADER": "Macros",
    "DESCRIPTION": "A macro is a set of saved actions that help customer service agents easily complete tasks. The agents can define a set of actions like tagging a conversation with a label, sending an email transcript, updating a custom attribute, etc., and they can run these actions in a single click.",
    "LEARN_MORE": "Learn more about macros",
    "COUNT": "{n} macro | {n} macros",
    "HEADER_BTN_TXT": "Ajouter une macro",
    "HEADER_BTN_TXT_SAVE": "Enregistrer une macro",
    "LOADING": "Récupération des macros",
    "SEARCH_PLACEHOLDER": "Search macros...",
    "NO_RESULTS": "No macros found matching your search",
    "ERROR": "Une erreur s'est produite. Veuillez réessayer",
    "ORDER_INFO": "Les macros s'exécuteront dans l'ordre où vous ajoutez vos actions. Vous pouvez les réorganiser en les glissant par la poignée à côté de chaque nœud.",
    "ADD": {
      "FORM": {
        "NAME": {
          "LABEL": "Nom de la macro",
          "PLACEHOLDER": "Entrez un nom pour votre macro",
          "ERROR": "Le nom est requis pour créer une macro"
        },
        "ACTIONS": {
          "LABEL": "Actions"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Macro ajoutée avec succès",
        "ERROR_MESSAGE": "Impossible de créer une macro, veuillez réessayer plus tard"
      }
    },
    "LIST": {
      "TABLE_HEADER": {
        "NAME": "Nom",
        "CREATED BY": "Créé par",
        "LAST_UPDATED_BY": "Dernière mise à jour par",
        "VISIBILITY": "Visibilité",
        "ACTIONS": "Actions"
      },
      "404": "Aucune macro trouvée"
    },
    "DELETE": {
      "TOOLTIP": "Supprimer la macro",
      "CONFIRM": {
        "MESSAGE": "Êtes-vous sûr de vouloir supprimer ",
        "YES": "Oui, supprimer",
        "NO": "Non"
      },
      "API": {
        "SUCCESS_MESSAGE": "Macro supprimée",
        "ERROR_MESSAGE": "Une erreur est survenue lors de la suppression de la macro. Veuillez réessayer plus tard"
      }
    },
    "VIEW": {
      "TOOLTIP": "View macro"
    },
    "EDIT": {
      "TOOLTIP": "Modifier la macro",
      "API": {
        "SUCCESS_MESSAGE": "Macro mise à jour",
        "ERROR_MESSAGE": "Impossible de mettre à jour Macro, merci de réessayer plus tard"
      }
    },
    "EDITOR": {
      "START_FLOW": "Démarrer le flux",
      "END_FLOW": "Arrêter le flux",
      "LOADING": "Récupération de la macro",
      "ADD_BTN_TOOLTIP": "Ajouter nouvelle action",
      "DELETE_BTN_TOOLTIP": "Supprimer une action",
      "VISIBILITY": {
        "LABEL": "Visibilité des macros",
        "GLOBAL": {
          "LABEL": "Publique",
          "DESCRIPTION": "Cette macro est visible pour tous les agents de ce compte.",
          "CREATE_DISABLED_DESCRIPTION": "Only administrators can create public macros.",
          "EDIT_DISABLED_DESCRIPTION": "Only administrators can edit public macros."
        },
        "PERSONAL": {
          "LABEL": "Privé",
          "DESCRIPTION": "Cette macro sera privée pour vous et ne sera pas accessible aux autres."
        }
      }
    },
    "EXECUTE": {
      "BUTTON_TOOLTIP": "Exécuter",
      "PREVIEW": "Aperçu de la macro",
      "EXECUTED_SUCCESSFULLY": "Macro exécutée"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "Attribute key is required",
      "FILTER_OPERATOR_REQUIRED": "Filter operator is required",
      "VALUE_REQUIRED": "La valeur est requise",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "Value must be between 1 and 998",
      "ACTION_PARAMETERS_REQUIRED": "Action parameters are required",
      "ATLEAST_ONE_CONDITION_REQUIRED": "At least one condition is required",
      "ATLEAST_ONE_ACTION_REQUIRED": "At least one action is required"
    },
    "ACTIONS": {
      "ASSIGN_TEAM": "Attribuer une équipe",
      "ASSIGN_AGENT": "Attribuer un agent",
      "ADD_LABEL": "Ajouter une étiquette",
      "REMOVE_LABEL": "Supprimer une étiquette",
      "REMOVE_ASSIGNED_AGENT": "Remove Assigned Agent",
      "REMOVE_ASSIGNED_TEAM": "Supprimer l’équipe assignée",
      "SEND_EMAIL_TRANSCRIPT": "Envoyer une transcription par e-mail",
      "MUTE_CONVERSATION": "Mettre la conversation en sourdine",
      "SNOOZE_CONVERSATION": "Clôturer la conversation",
      "RESOLVE_CONVERSATION": "Résoudre la conversation",
      "SEND_ATTACHMENT": "Envoyer la pièce jointe",
      "SEND_MESSAGE": "Envoyer un message",
      "CHANGE_PRIORITY": "Modifier la priorité",
      "ADD_PRIVATE_NOTE": "Ajouter une note privée",
      "SEND_WEBHOOK_EVENT": "Envoyer un événement Webhook"
    },
    "PRIORITY_TYPES": {
      "NONE": "Aucun",
      "LOW": "Faible",
      "MEDIUM": "Moyenne",
      "HIGH": "Élevé",
      "URGENT": "Urgent"
    }
  }
}
